"use strict";
import { TagsModel } from "@/models/tags.model";
import { VirtualDesktopProModel } from "@/models/virtualdesktop.model";
import { v4 } from "uuid";
import { Timestamp } from "@/components/virtual-element/utils";
import { OnlineList } from "@/components/virtual-shop/item";
export class ShopItem {
  constructor() {
    this.id = null;
    this.name = null;
    this.icon = null;
    this.oldId = null;
  }
  static create(item) {
    const _item = new this();
    _item.id = item.id;
    _item.name = item.name;
    _item.icon = item.logo;
    _item.oldId = item.oldId;
    return _item;
  }
}
export class ItemProxyColumn {
  constructor() {
    this.address = null;
    this.ipAlias = null;
    this.name = null;
    this.area = null;
  }
}
export class ItemProductColumn {
  constructor() {
    this.renew = 0;
  }
}
export class ItemRuntime {
  constructor() {
    this.status = "ready";
  }
}
export class RemoteItemRuntime {
  constructor() {
    this.status = "ready";
  }
}
export class VirtualDesktopItemColumn {
  constructor() {
    this._resource = new VirtualDesktopProModel();
    this.id = null;
    this.oldId = null;
    this.ip = null;
    this.name = null;
    this.title = null;
    this.proxy = new ItemProxyColumn();
    this.expire = 0;
    this.shops = [];
    this.status = null;
    this.marks = new TagsModel();
    this.price = 0;
    this.canUseDays = 0;
    this.canUseSeconds = 0;
    // config: ConfigModel = new ConfigModel;
    this.launcher_progress = 0;
    this.remote_launcher_progress = 0;
    this.osName = "";
    this.osVersion = "";
    this.expire_in_seconds = 0;
    // product = new ItemProductColumn();
    this.owners = 0;
    this.type = null;
    this.files = 0;
    this.expectOpenTime = 0;
    // button_status:ButtonModel = new ButtonModel();
    this.end_time = 0;
    this.onLineList = new OnlineList();
    this.runtime = new ItemRuntime();
    this.remote_runtime = new RemoteItemRuntime();
    this._hash = null;
  }
  get endTimestamp() {
    return new Timestamp(this.end_time * 1e3);
  }
  get modeStatus() {
    if (this.shops.length > 0 && this.status == "open" && this.marks.is("UNBOUND_HOST") === false) {
      return "active";
    }
  }
  get modelResource() {
    return this._resource;
  }
  set modelResource(model) {
    this._resource = model;
  }
  // launcher:VirtualDesktopLauncher;
  refresh() {
    this._hash = v4();
  }
  get hash() {
    return this._hash;
  }
  static create(item) {
    const _item = new this();
    _item.id = item.id;
    _item.oldId = item.oldId;
    _item.title = item.name;
    _item.ip = item.address;
    _item.name = item.name;
    _item.proxy.address = item.address;
    _item.proxy.ipAlias = item.addressAlias;
    _item.proxy.name = item.region.name;
    _item.price = item.price;
    _item.expire_in_seconds = item.canUseSeconds;
    _item.expire = item.get("validity.day");
    _item.status = item.status;
    _item.type = item.type;
    _item.canUseDays = item.canUseDays;
    _item.canUseSeconds = item.canUseSeconds;
    _item.osName = item.osName;
    _item.osVersion = item.osVersion;
    _item.end_time = item.expiredTime;
    _item.owners = item.adminCount;
    _item.expectOpenTime = item.expectOpenTime;
    _item.files = item.fileCount;
    _item.modelResource = item;
    _item.onLineList = new OnlineList();
    _item.marks = new TagsModel();
    _item.marks.tags = item.marks.tags;
    if (item.autoRenew) {
      _item.marks.add("AUTO_RENRW");
    }
    for (const _shop of item.shops.datas) {
      _item.shops.push(ShopItem.create(_shop));
    }
    return _item;
  }
}
